import {
  InstructionsRoute,
  MetricsRoute,
  MetricEditorRoute,
  OverviewRoute,
  SkillEditorRoute,
  SkillsRoute,
  TagEditorRoute,
  TagsRoute,
  KnowledgeEditorRoute,
  KnowledgeRoute,
  ToolEditorRoute,
  ToolsRoute,
} from 'components/@home/@settings/Tabs/Agents/AgentBuilderRouteElements';
import { useAgentEdit } from 'components/@home/@settings/Tabs/Agents/AgentEditContext';
import React from 'react';
import { Navigate, useMatch, useRoutes } from 'react-router';
import agenticSectionPath from 'utils/agenticSectionPath';

const agentBuilderRouteConfig = [
  { path: 'overview', element: <OverviewRoute /> },
  { path: 'instructions', element: <InstructionsRoute /> },
  { path: 'instructions/:kind', element: <InstructionsRoute /> },
  { path: 'skills', element: <SkillsRoute /> },
  { path: 'skills/:skillId', element: <SkillEditorRoute /> },
  { path: 'tools', element: <ToolsRoute /> },
  { path: 'tools/:toolId', element: <ToolEditorRoute /> },
  { path: 'knowledge', element: <KnowledgeRoute /> },
  { path: 'knowledge/:knowledgeId', element: <KnowledgeEditorRoute /> },
  { path: 'tags', element: <TagsRoute /> },
  { path: 'tags/:tagId', element: <TagEditorRoute /> },
  { path: 'metrics', element: <MetricsRoute /> },
  { path: 'metrics/:metricId', element: <MetricEditorRoute /> },
];

const AgentBuilderRoutes = () => {
  const { authCompany, flow } = useAgentEdit();
  const sectionBase = agenticSectionPath(authCompany);
  const match = useMatch({ path: `${sectionBase}/${flow?._id}/*`, end: false });
  const splat = match?.params['*'] || '';
  const flowBase = match?.pathnameBase || `${sectionBase}/${flow?._id}`;
  const routePathname = splat ? `${flowBase}/${splat}` : flowBase;
  const instructionsPath = `${flowBase}/instructions`;

  return useRoutes(
    [
      ...agentBuilderRouteConfig,
      { index: true, element: <Navigate to={instructionsPath} replace /> },
      { path: '*', element: <Navigate to={instructionsPath} replace /> },
    ],
    routePathname,
  );
};

export default AgentBuilderRoutes;
